import React from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import GetIcons from "./GetIcons";
// import questionStore from "../store/QuestionStore";
import { useStore } from "../../helpers";
import { formatName } from "../utitlity/formatName";
import { toJS } from "mobx";

const ProfileQuestions = () => {
  const rootStore = useStore();
  const { questionStore } = rootStore;
  console.log(toJS(questionStore));
  const title = questionStore.activeTab.title;
  const tabs = questionStore.tabs;

  return (
    <>
      <List>
        {tabs.map((question) => {
          let questiontitle = formatName(question);
          return (
            <ListItemButton
              onClick={() => {
                questionStore.showOptions(question);
              }}
              alignItems="flex-start"
              selected={title === question}
              key={question}
            >
              <ListItemIcon>
                <GetIcons icon_name={questiontitle} />
              </ListItemIcon>
              <ListItemText>
                <h5>{questiontitle}</h5>
              </ListItemText>
            </ListItemButton>
          );
        })}
      </List>
    </>
  );
};

export default ProfileQuestions;
